import "../../../../../css/CashflowModeller2/ConfirmationModal/ConfirmationModal.css";
import ButtonSmall from "../../../../../frontend/DesignSystem/Buttons/ButtonSmall";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/close.svg";

/**
 * ConfirmationModal component displays a modal dialog to confirm user actions when there are unsaved changes.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} [props.title="Unsaved Changes"] - The title displayed at the top of the modal.
 * @param {string} [props.message=""] - The message to display in the modal (currently unused).
 * @param {Function} props.onSave - Callback function invoked when the user chooses to save changes.
 * @param {Function} props.onDiscard - Callback function invoked when the user chooses to discard changes.
 * @param {Function} props.onCancel - Callback function invoked when the user cancels or closes the modal.
 *
 * @returns {JSX.Element} The rendered confirmation modal component.
 */
const ConfirmationModal = ({
  title = "Unsaved Changes",
  message = "",
  onSave,
  onDiscard,
  onCancel,
}) => {
  return (
    <div className="confirmation-backdrop">
      <div className="confirmation-modal">
        <CloseIcon className="close-icon" onClick={onCancel} />
        <div className="Label-Large-Bold">{title}</div>
        <div className="Content-Large">
          You have unsaved changes. Would you like to save them before exiting?
        </div>
        <div className="confirmation-buttons">
          <ButtonSmall buttonText="Discard" onClick={onDiscard} />
          <ButtonSmall buttonText="Save" onClick={onSave} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
